var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-input',{attrs:{"type":"text","placeholder":_vm.placeholder,"required":_vm.required},model:{value:(_vm.input_text),callback:function ($$v) {_vm.input_text=$$v},expression:"input_text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }